import { useTranslation } from "react-i18next";
import styled from "styled-components"
import { Button } from "../../../../ui/button"
import { Textarea } from "../../../../ui/textarea"

import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from "../../../../ui/dropdown-menu"
import { useEffect, useState, useRef } from "react"
import { useNavigate, useParams, useSearchParams } from "react-router-dom"
import { useItem } from "../../../controllers/ItemController"
import { useAuthorisedValues } from "../../../controllers/AuthorisedValuesController";
import { Select, message } from "../../../../ui/ot"
import { Save } from 'lucide-react';

const BookDetailItems = () => {
    const { t } = useTranslation('translation')
    const i18nPrefix = "library.bookdetailitems."
    const [searchParams, setSearchParams] = useSearchParams();
    const itemnumber = searchParams.get('itemnumber');
    const navigate = useNavigate()
    const [bookData, setbookData] = useState([])
    const [damagedOption, setDamagedOption] = useState([])
    const [withdrawnOption, setWithdrawnOption] = useState([])
    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "post") {
                message.success("新增成功");
            } else if (axiosMode === "patch") {
                message.success("修改成功");
            } else if (axiosMode === "delete") {
                message.success("刪除成功");
            }
        } else if (status === "error") {
            if (axiosMode === "post") {
            } else if (axiosMode === "patch") {
                message.error("修改失敗");
            } else if (axiosMode === "delete") {
                message.error("刪除失敗");
            }
        }
        if (axiosMode !== "get") {
            // setModalOpen(false);
        }
    };
    const {
        ItemData,
        patchItemData,
        getItemData,
        transformData
    } = useItem({
        onBefore: () => { },
        onFinish: onFinish
    })

    const {
        getAuthorisedValuesData
    } = useAuthorisedValues({

    })



    useEffect(() => {
        //拿館藏資訊
        getItemData({
            itemnumber: itemnumber
        }).then((response) => {
            let data = response?.data || []
            let data_first = data.find((ele) => true)
            setbookData(data_first)
        })
        //拿損壞原因下拉選單
        getAuthorisedValuesData({
            category: "DAMAGED",
        }).then((response) => {
            let data = response?.data || []
            setDamagedOption(data)
        })
        //拿停用原因下拉選單
        getAuthorisedValuesData({
            category: "WITHDRAWN",
        }).then((response) => {
            let data = response?.data || []
            setWithdrawnOption(data)
        })
    }, [])




    const fileInputRef = useRef(null);
    const uploadFile = () => {
        const fileInput = fileInputRef.current;
        const file = fileInput.files[0];
        console.log(file)
        if (file) {
            const formData = new FormData();
            formData.append('file', file);


        }
    };
    return (
        <MainContainer>
            <Title>
                <span className="mr-2">
                    Item details for
                </span>
                {bookData?.bib_title}{bookData?.bib_subtitle}
            </Title>
            <ButtonGroup>
                <DropdownMenu>
                    <DropdownMenuTrigger><Button variant="outline" >
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="mr-2 bi bi-plus-lg" viewBox="0 0 16 16">
                            <path fill-rule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2" />
                        </svg>
                        {t("post")}</Button></DropdownMenuTrigger>
                    <DropdownMenuContent>
                        <DropdownMenuItem onClick={() => { navigate(`/library/backstage/AddMARC`) }}>{t("library.backstage.AddMARC.")}</DropdownMenuItem>
                        <DropdownMenuItem onClick={() => { navigate(`/library/backstage/BookDetail?bib_biblionumber=${bookData?.bib_biblionumber}`) }}>{t("library.backstage.AddItem.")}</DropdownMenuItem>
                        {/* <DropdownMenuItem disabled>新增訂閱</DropdownMenuItem> */}
                        {/* <DropdownMenuItem disabled>新增子紀錄</DropdownMenuItem> */}
                    </DropdownMenuContent>
                </DropdownMenu>
                {/* <DropdownMenu>
                    <DropdownMenuTrigger><Button variant="outline" >
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="mr-2 bi bi-pencil-square" viewBox="0 0 16 16">
                            <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                            <path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z" />
                        </svg>
                        {t("patch")}
                    </Button></DropdownMenuTrigger>
                    <DropdownMenuContent>
                        <DropdownMenuItem onClick={() => { navigate(`/library/backstage/EditMARC?bib_biblionumber=${bookData?.bib_biblionumber}`) }}>{t("library.backstage.EditMARC.")}</DropdownMenuItem>
                        <DropdownMenuItem disabled>使用範本修改紀錄</DropdownMenuItem>
                        <DropdownMenuItem onClick={() => { navigate(`/library/backstage/EditItem/${bookData?.bib_biblionumber}/${itemnumber}`) }}>{t("library.backstage.EditItem.")}</DropdownMenuItem>
                        <DropdownMenuItem disabled>批量編輯項目</DropdownMenuItem>
                        <DropdownMenuItem disabled>批量刪除項目</DropdownMenuItem>
                        <DropdownMenuItem disabled>附加項目</DropdownMenuItem>
                        <DropdownMenuItem style={{ 'cursor': "pointer" }} onClick={() => fileInputRef.current.click()}>{t("library.backstage.UploadImage.")}</DropdownMenuItem>
                        <DropdownMenuItem disabled>編輯為新的（重複）</DropdownMenuItem>
                        <DropdownMenuItem disabled>透過 Z39.50 / SRU 替換項目</DropdownMenuItem>
                        <DropdownMenuItem disabled>刪除紀錄</DropdownMenuItem>
                        <DropdownMenuItem disabled>刪除所有項目</DropdownMenuItem>
                    </DropdownMenuContent>
                </DropdownMenu> */}
                <Button variant="outline"
                    onClick={() => {
                        let data = transformData(bookData)
                        patchItemData([data])
                    }}
                >
                    <Save size={16} />
                    {t("save")}
                </Button>
                {/* <DropdownMenu>
                    <DropdownMenuTrigger>
                        <Button variant="outline" >
                            <Save size={16} />
                            {t("save")}
                        </Button>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent>
                        <DropdownMenuItem>BIBTEX</DropdownMenuItem>
                        <DropdownMenuItem>Dublin Core</DropdownMenuItem>
                        <DropdownMenuItem>MARCXML</DropdownMenuItem>
                        <DropdownMenuItem>MARC (non-Unicode/MARC-8) </DropdownMenuItem>
                        <DropdownMenuItem>MARC (Unicode/UTF-8) </DropdownMenuItem>
                        <DropdownMenuItem>MARC (Unicode/UTF-8),Standard </DropdownMenuItem>
                        <DropdownMenuItem>MODS (XML)</DropdownMenuItem>
                        <DropdownMenuItem>RIS</DropdownMenuItem>
                    </DropdownMenuContent>
                </DropdownMenu> */}

            </ButtonGroup>
            <WhiteBox>
                <div className=' text-xl font-bold text-gray-500' >
                    {bookData?.bib_title}
                </div>
                <div className='text-lg  font-bold'>
                    <div>
                        {bookData?.bib_subtitle}
                    </div>
                    <div>
                        {bookData?.bib_author}
                    </div>
                </div>
                <ItemContainer className='mt-3'>
                    <ItemBox><GrayText>{t(`${i18nPrefix}Biblionumber`)}:</GrayText> {bookData?.bib_biblionumber}</ItemBox>
                    <ItemBox><GrayText>ISBN:</GrayText> {bookData?.bibitem_isbn}</ItemBox>
                    <ItemBox><GrayText>{t(`${i18nPrefix}Publication_details`)}:</GrayText> {bookData?.bib_publisher} </ItemBox>
                    <ItemBox><GrayText>{t(`${i18nPrefix}Physical details`)}:</GrayText> {bookData?.bibitem_pages}{bookData?.bibitem_illus}{bookData?.bibitem_size} </ItemBox>
                    <ItemBox><GrayText>{t(`${i18nPrefix}NoOfItems`)}:</GrayText> {bookData?.items_count}</ItemBox>
                </ItemContainer>
            </WhiteBox>
            <WhiteBox>
                <SubTitle>
                    {t(`${i18nPrefix}Barcode`)} {bookData?.item_barcode}
                </SubTitle>
                <ItemTitle>{t(`${i18nPrefix}Item information.Item information`)}</ItemTitle>
                <ItemContainer>
                    <ItemBox><GrayText>{t(`${i18nPrefix}Item information.Home library`)}:</GrayText>{bookData?.item_branchname_home}</ItemBox>
                    <ItemBox><GrayText>{t(`${i18nPrefix}Item information.Item_type`)}:</GrayText> {bookData?.item_itype_description}</ItemBox>
                    <ItemBox><GrayText>{t(`${i18nPrefix}Item information.Item_call_number`)}:</GrayText>{bookData?.item_itemcallnumber}</ItemBox>
                    <ItemBox><GrayText>{t(`${i18nPrefix}Item information.Replacement price`)}:</GrayText>{bookData?.item_replacement_price}</ItemBox>

                </ItemContainer>
                <ItemTitle>{t(`${i18nPrefix}Statuses.Statuses`)}</ItemTitle>
                <ItemContainer>
                    <ItemBox><GrayText>{t(`${i18nPrefix}Statuses.Current library`)}:</GrayText>{bookData?.item_branchname_holding}</ItemBox>
                    <ItemBox><GrayText>{t(`${i18nPrefix}Statuses.Checkout status`)}:</GrayText>{bookData?.issue_cancheckout ? t(`${i18nPrefix}CanCheckout`) : t(`${i18nPrefix}CantCheckout`)}</ItemBox>
                    <ItemBox>
                        <GrayText>{t(`${i18nPrefix}Statuses.Damaged status`)}:</GrayText>
                        <Select
                            allowClear={true}
                            onChange={(value) => {
                                setbookData((pre) => {
                                    return {
                                        ...pre,
                                        item_damaged: value
                                    }
                                })
                            }}
                            value={bookData?.item_damaged}
                            options={damagedOption?.map((value) => {
                                return {
                                    label: `${value?.description}(${value?.description_opac}) `,
                                    value: value?.authorised_value
                                }
                            })}
                        />

                    </ItemBox>
                    <ItemBox>
                        <GrayText>{t(`${i18nPrefix}Statuses.Withdrawn status`)}:</GrayText>
                        <Select
                            allowClear={true}
                            onChange={(value) => {
                                setbookData((pre) => {
                                    return {
                                        ...pre,
                                        item_withdrawn: value
                                    }
                                })
                            }}
                            value={bookData?.item_withdrawn}
                            options={withdrawnOption?.map((value) => {
                                return {
                                    label: `${value?.description}(${value?.description_opac}) `,
                                    value: value?.authorised_value
                                }
                            })}
                        />

                    </ItemBox>

                </ItemContainer>
                <ItemTitle>{t(`${i18nPrefix}History.History`)}</ItemTitle>
                <ItemContainer>
                    <ItemBox><GrayText>{t(`${i18nPrefix}History.Accession date`)}:</GrayText>{bookData?.bib_datecreated}</ItemBox>
                    <ItemBox><GrayText>{t(`${i18nPrefix}History.Total checkouts`)}:</GrayText>{bookData?.items_count} ({t(`${i18nPrefix}History.View item's checkout history`)}) </ItemBox>
                    <ItemBox><GrayText>{t(`${i18nPrefix}Statuses.Current renewals`)}:</GrayText>{bookData?.item_renewal_count}</ItemBox>
                    <ItemBox><GrayText>{t(`${i18nPrefix}History.Last seen`)}:</GrayText>{bookData?.item_lastseen}</ItemBox>
                    <ItemBox><GrayText>{t(`${i18nPrefix}History.Last borrowed`)}:</GrayText>{bookData?.item_datelastborrowed} </ItemBox>
                    <ItemBox>
                        <GrayText>{t(`${i18nPrefix}History.Public note`)}:</GrayText>
                        <div>
                            <Textarea
                                onChange={(e) => {
                                    setbookData((pre) => {
                                        return {
                                            ...pre,
                                            item_public_notes: e.target.value
                                        }
                                    })
                                }} value={bookData?.item_public_notes} placeholder={t(`${i18nPrefix}History.Type your message here`)} />
                        </div>


                    </ItemBox>
                    <ItemBox>
                        <GrayText>{t(`${i18nPrefix}History.Non public note`)}:</GrayText>
                        <div>
                            <Textarea
                                onChange={(e) => {
                                    setbookData((pre) => {
                                        return {
                                            ...pre,
                                            item_internal_notes: e.target.value
                                        }
                                    })
                                }}
                                value={bookData?.item_internal_notes} placeholder={t(`${i18nPrefix}History.Type your message here`)} />
                        </div>

                    </ItemBox>
                </ItemContainer>
            </WhiteBox>
        </MainContainer>
    )
}

const MainContainer = styled.div`
width: 100%;
display: flex;
-webkit-box-pack: center;
justify-content: space-around;
flex-direction: column;
-webkit-box-align: start;
align-items: start;
padding: 2em;
gap: 0.5em;
-webkit-flex-wrap: wrap;
`

const Title = styled.div`
text-align: left;
width: 100%;
font-size: 1.6em;
font-weight: 600;
`

const SubTitle = styled.div`
text-align: left;
// width: 90%;
font-size: 1.2em;
font-weight: 600;
`

const ButtonGroup = styled.div`
width: 100%;
display: flex;
gap: 1em;
align-items: flex-start;
`

const WhiteBox = styled.div`
background-color: #fff;
padding: 1em;
width: 100%;
`

const GrayText = styled.div`
color: #929292;
width: 8em;
text-align: end;
padding-right: 1em;
`

const ItemTitle = styled.div`
color: #929292;
text-align: left;
font-size: 1.1em;
font-weight: 600;
`

const ItemContainer = styled.div`
width: fit-content;

`

const ItemBox = styled.div`
padding: 0.1em;
margin-left: 1em;
/* width: fit-content; */
border-bottom: 1px solid #d4d4d4;
display: flex;
flex-direction: row;
flex-wrap: nowrap;
align-items: center;
gap: 10px 20px;
margin-top:5px;
margin-bottom:5px;

`

export default BookDetailItems